import React from 'react';
import 'styles/404.css';

export default props => (
  <div id="not-found">
    <div id="content">
      <div className="clearfix" />

      <div id="main-body">
        <p className="enormous-font bree-font"> 404 </p>
        <p className="big-font">
          {' '}
          This is just embarrassing; this page does not exist...{' '}
        </p>
        <hr />
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/GenericNotFound.jsx